module.exports = __webpack_public_path__ + "img/Naissance.bf9e550.jpg";